<template>
  <MetricCard
    apiEndpoint="/tiktok/reach"
    metricName="REACH"
    :formatData="formatData"
    srcName="TikTok"
  />
</template>

<script setup>
import MetricCard from '@/components/MetricCard.vue';
import { formatNumber } from '@/utils/helperFunctions';
const formatData = (data) => formatNumber(data.data);
</script>
